export default from './Home';


/** WEBPACK FOOTER **
 ** ./app/components/home/index.js
 **/